import { useState } from "react";

import Breadcrumb from "../Breadcrumb";
import { useFetchFolder } from "../api";

// Folder navigation inside the file/folder select modals. Every modal starts
// at its root folder.
function useFolderResource({ currentRootFolder }) {
  const [selectedFolder, setSelectedFolder] = useState(null);
  const currentFolderId = selectedFolder?.id ?? currentRootFolder.id;
  const currentFolderNamespace =
    selectedFolder?.namespace ?? currentRootFolder.namespace;

  const { data: currentFolder, isLoading: loading } = useFetchFolder(
    currentFolderId,
    currentFolderNamespace,
  );

  const handleNavigate = ({ id, namespace }) => {
    setSelectedFolder({ id, namespace });
  };

  const breadcrumb = (
    <Breadcrumb folder={currentFolder} handleNavigate={handleNavigate} />
  );

  return { loading, currentFolder, handleNavigate, breadcrumb };
}

export default useFolderResource;
